import { ReportParameterTypeEnumSchema } from "@/Enums/ReportParameterType";
import { z } from "zod";

export const ReportParameterHistoryDtoSchema = z.object({
    id: z.string(),
    reportId: z.number(),
    name: z.string(),
    description: z.string(),
    type: ReportParameterTypeEnumSchema,
});